import { render } from "./UiCell.vue?vue&type=template&id=abdff6d2&ts=true"
import script from "./UiCell.vue?vue&type=script&lang=ts"
export * from "./UiCell.vue?vue&type=script&lang=ts"

import exportComponent from "/home/dima/Work/pioneer-lk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__